import {Reason, TClientData} from './client-message.interface';
import {IClientMessageDetails} from './client-message-details.interface';
import {entryof} from 'frontier/nucleus/src/lib/utils/entryof';

interface IMappedMessage {
  label: string;
  value: string | boolean | Reason;
  key: keyof TClientData;
}

const attributeToLabel: Record<keyof TClientData, string> = {
  'Action': 'Begründungsindex',
  'ActionStr': 'Begründung',
  'Note': 'Notiz',
  'Email': 'E-Mail',
  'Phone': 'Telefon',
  'InvoiceNumber': 'Rechnungsnummer',
  'ClientHasPayer': 'Kassenpatient',
  'ClientIdentifierNumber': 'Versichertennummer',
  'ClientPayerName': 'Kassenbezeichnung',
  'ClientPayerNumber': 'Kassennummer',
  'ClientFirstName': 'Vorname',
  'ClientLastName': 'Nachname',
  'ClientStreet': 'Straße',
  'ClientPostCode': 'PLZ',
  'ClientCity': 'Ort',
  'ClientCountryCode': 'Land',
  'ActionDescription': 'Aktionsbeschreibung',
  DocumentAssigned: '',
  DisplayAction: '',
}

const valueMap: { [key in Reason | 'true' | 'false']: string } = {
  [Reason.changeInsuranceCompany]: 'Krankenkasse ändern',
  [Reason.changeInvoiceAddress]: 'Rechnungsadresse ändern',
  [Reason.submitAuthorization]: 'Genehmigung nachreichen',
  [Reason.other]: 'Sonstige Bemerkung',
  'false': 'Nein',
  'true': 'Ja',
}

export class ClientMessageMapper {
  static toModel(message: TClientData): IClientMessageDetails {
    const entries: entryof<TClientData> = Object.entries(message) as entryof<TClientData>;
    const mappedMessage: IMappedMessage[] = entries
      .filter(([key, value]) => ClientMessageMapper.filterAttributes(message.Action, key))
      .map(([key, value]): IMappedMessage => {
        let valueKey: Reason | 'true' | 'false';
        if (typeof value === 'boolean') {
          valueKey = value ? 'true' : 'false';
        }
        return {label: attributeToLabel[key], value: valueKey ? valueMap[valueKey] : value, key};
      });
    return {
      rows: mappedMessage,
      actionDescription: message.ActionDescription,
      documentAssigned: message.DocumentAssigned,
      displayAction: message.DisplayAction,
    };
  }

  private static filterAttributes(Action: Reason, key: string): boolean {
    switch (Action) {
      case Reason.submitAuthorization:
      case Reason.other:
        if (['ActionStr', 'Note', 'Email', 'Phone'].includes(key)) {
          return true;
        }
        break;
      case Reason.changeInsuranceCompany:
        if (['ActionStr', 'Note', 'Email', 'Phone', 'ClientHasPayer', 'ClientPayerName', 'ClientIdentifierNumber']
          .includes(key)) {
          return true;
        }
        break;
      case Reason.changeInvoiceAddress:
        if (['ActionStr', 'Note', 'Email', 'Phone', 'ClientFirstName', 'ClientLastName',
          'ClientStreet', 'ClientPostCode', 'ClientCity', 'ClientCountryCode'].includes(key)) {
          return true;
        }
        break;
    }
    return false;
  }
}
